const Enter = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 26"
            width="26"
            height="26"
            {...props}
        >
            <path
                d="M25 2H9c-.551 0-1 .449-1 1v9c0 2-2 2-2 2H1c-.551 0-1 .449-1 1v8c0 .551.449 1 1 1h24c.551 0 1-.449 1-1V3c0-.551-.449-1-1-1zm-3 12c0 1.436-1.336 4-4 4h-3.586l1.793 1.793c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.5-3.5c-.391-.391-.391-1.023 0-1.414l3.5-3.5c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414L14.414 16H18c1.398 0 2-1.518 2-2v-2c0-.553.447-1 1-1s1 .447 1 1v2z"
                fill="#030104"
            />
        </svg>
    );
};

export default Enter;
